import { useNavigate } from "react-router-dom";
import MenuTop from "../../../../components/menu/top/menu-top";
import './style.css';
import { useEffect, useState } from "react";
import { fetchClientsService } from "../../../../features/client/service/client-service";
import Loader from "../../../../components/loader/loader";
import { ListComponent } from "../../../../components/list/list";
import MenuContext, { DISPLAY_TYPE } from "../../../../components/menu/context/menu-context";

export function ListClient() {
    const navigate = useNavigate();
    const [ isLoading, setIsLoading ] = useState(false);
    const [clients, setClients] = useState<any[]>([]);

    useEffect(() => {
        const fetchClients = async () => {
            try {
                setIsLoading(true);
                const clients = await fetchClientsService();
                setClients(clients);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchClients();
    }, []);

    return (
        <div className="container-client">
            <MenuTop />
            {isLoading && <Loader />}
            <div className='container-client__content'>
                <div className="container-client__content__title">
                    <h1 className="container-client__content__title-text">Listagem de clientes</h1>
                    <MenuContext 
                        display={DISPLAY_TYPE.INLINE} 
                        clickedAdd={() => navigate('/cliente')}
                    />
                </div>
                
                {clients.length > 0 ? (
                    <ListComponent 
                        data={clients} 
                        handleRedirect={(id: string) => navigate(`/cliente/${id}`)}
                    />
                ) : (
                    !isLoading && <p className="empty-message">Nenhum cliente encontrado.</p>
                )}
            </div>
        </div>
    )
}